import moment from "moment";

import { IoIosList } from "react-icons/io";
import { IoCalendarOutline } from "react-icons/io5";
import { LuLayoutDashboard } from "react-icons/lu";
import { GoFile } from "react-icons/go";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { GrFormNextLink } from "react-icons/gr";
import { transformTodoContent } from "../../../../scheduler/component/function/common";

export const projectMenus = [
  {
    name: "대시보드",
    icon: LuLayoutDashboard,
  },
  {
    name: "스케쥴표",
    icon: IoCalendarOutline,
  },
  {
    name: "일정",
    icon: IoIosList,
  },
  { name: "파일", icon: GoFile },
  { name: "리포트", icon: HiOutlineDocumentReport },
];

// 프로젝트 색상 반환
export const isColor = (name) => {
  if (name.includes("fixed")) return "#FFC455";
  if (name.includes("cmpny") || name === "C") return "#0074ca";
  if (name.includes("other")) return "#ED5583";
  if (name.includes("group") || name === "G") return "#F46F02";

  return "#533b70";
};

// 숫자 기반 고유 색상(RGBA) 생성
export const isCmpnyColor = (number) => {
  const r = (number >> 16) & 0xff;
  const g = (number >> 8) & 0xff;
  const b = number & 0xff;

  // RGB 색상 문자열 반환
  return `rgba(${r}, ${g}, ${b}, 0.2)`;
};

// 프로젝트 문자열 한글로 변환
export const isCategory = (name) => {
  if (!name) return "";

  if (name.includes("fixed")) return "즐겨찾기";
  if (name.includes("cmpny")) return "업무";
  if (name.includes("other")) return "외부업체";
  if (name.includes("group")) return "모임";
};

// 해당 웹소켓 찾기
export const targetWebSocket = (data = [], selected) => {
  if (!selected) return;

  const extractRoomId = (url) => {
    const params = new URLSearchParams(url.split("?")[1]);
    return params.get("room");
  };

  const target = data.find((ws) => extractRoomId(ws.url) == selected.roomId);
  return target;
};

// 프로젝트 정보와 소속 회사에 따라 색상 반환
export const getProjectColor = (project, company) => {
  if (project.pinnedYn === "Y") return "#FFC455";
  if (project.gbn === "G") return "#F46F02";
  if (project.gbn === "C" && company.some((item) => item.cmpnyNo === project.orgNo))
    return "#0074ca";
  return "#ED5583";
};

const labelObj = {
  title: "일정 제목",
  startDt: "시작시간",
  endDt: "종료시간",
  place: "주소",
  placeDetail: "상세주소",
  managerNo: "담당자",
  workerNos: "실무자",
  memo: "메모",
  publicYn: "공개여부",
  icon: "아이콘",
  pushMinute: "알림",
  todo: "할일",
  certainType: "종류",
  completeYn: "완료여부",
  projectName: "프로젝트명",
  projectNm: "프로젝트명",
};

const labelOnlyChangeKeys = {
  content: "공지사항",
  icon: "아이콘",
  managerNo: "담당자",
};

export const parseChangeData = (changeDataStr, changeType) => {
  try {
    if (!changeDataStr) return null;
    const parsed = JSON.parse(changeDataStr);

    const elements = [];

    const start = parsed.startDt;
    const end = parsed.endDt;
    const bothAreObjects =
      start &&
      end &&
      typeof start === "object" &&
      typeof end === "object" &&
      start !== null &&
      end !== null;

    if (bothAreObjects && start.old && end.old && start.new && end.new) {
      elements.push(
        <div key="time">
          <span>시간:</span> <strong>{showEventTime(start.old, end.old)}</strong>
          <i>
            <GrFormNextLink />
          </i>
          <strong>{showEventTime(start.new, end.new)}</strong>
        </div>,
      );
    }

    return [
      ...elements,
      ...Object.entries(parsed)
        .filter(([key]) => {
          if (changeType === "DELETE") return key === "title";
          if (key === "startDt" || key === "endDt") return false;
          return labelObj[key] !== undefined || labelOnlyChangeKeys[key] !== undefined;
        })
        .map(([key, value]) => {
          const label = labelObj[key];

          if (labelOnlyChangeKeys[key]) {
            return (
              <div key={key}>
                {chooseParticle(labelOnlyChangeKeys[key], "이가")} 변경되었습니다.
              </div>
            );
          }

          if (typeof value === "string") {
            if (value === "null") return null;
            return (
              <div key={key}>
                <span>{label}: </span> <strong>{value}</strong>
              </div>
            );
          }

          if (typeof value === "object" && value !== null) {
            let oldVal = value.old === "null" ? "" : value.old;
            let newVal = value.new === "null" ? "" : value.new;

            if (key === "memo") {
              oldVal = transformTodoContent(oldVal);
              newVal = transformTodoContent(newVal);
            }

            if (Array.isArray(oldVal)) oldVal = oldVal.length > 0 ? oldVal.join(", ") : "(없음)";
            else oldVal = oldVal === "null" ? "" : oldVal;

            if (Array.isArray(newVal)) newVal = newVal.length > 0 ? newVal.join(", ") : "(없음)";
            else newVal = newVal === "null" ? "" : newVal;

            oldVal = oldVal ? oldVal : "(없음)";
            newVal = newVal ? newVal : "(없음)";

            if (oldVal === "(없음)" && newVal === "(없음)") return null;

            return (
              <div key={key}>
                <span>
                  {label}
                  {": "}
                </span>
                <strong>{oldVal}</strong>
                <i>
                  <GrFormNextLink />
                </i>
                <strong>{newVal}</strong>
              </div>
            );
          }

          return null;
        })
        .filter(Boolean),
    ];
  } catch (error) {
    console.error("changeData 파싱 실패", error);
    return null;
  }
};

export const activityType = {
  SCHEDULE: "일정",
  NOTICE: "공지사항",
  INVITE: "멤버 초대",
  KICK: "멤버 내보내기",
  SCHEDULE_PDF_DOWNLOAD: "스케쥴표",
  PROJECT_INFO: "프로젝트 정보",
  PROJECT_ROOM: "채팅룸",
  OTHER: "기타",
};

export const changeType = {
  UPDATE: "수정",
  CREATE: "생성",
  DOWNLOAD: "다운로드",
  DELETE: "삭제",
};

// createdAt 배열 또는 문자열을 YYYY-MM-DD 형식으로 변환
const formatDateOnly = (createdAt) => {
  if (Array.isArray(createdAt)) {
    const [y, m, d] = createdAt;
    return moment(`${y}-${m}-${d}`).format("YYYY-MM-DD");
  }

  if (typeof createdAt === "string") {
    return moment(createdAt).format("YYYY-MM-DD");
  }

  return "";
};

// 날짜 배열을 HH:mm 형식으로 포맷
export const formatDate = (dateArray) => {
  if (!Array.isArray(dateArray)) return "";
  const [y, m, d, h, min, s] = dateArray;
  return moment(`${y}-${m}-${d} ${h}:${min}:${s}`).format("HH:mm");
};

// 히스토리를 날짜별로 묶고 최신순 정렬
export const groupHistories = (histories) => {
  const map = {};
  histories.forEach((history) => {
    const key = formatDateOnly(history.createdAt);
    if (!map[key]) map[key] = [];
    map[key].push(history);
  });

  const sorted = Object.fromEntries(Object.entries(map).sort(([a, b]) => (a < b ? 1 : -1)));
  return sorted;
};

// 이름을 gbn 여부에 가명 처리 or 그대로 반환
export const memberName = (isGrp, mberNm) => {
  if (isGrp && !mberNm) return "닉네임 미설정";
  if (isGrp) return mberNm;
  return `${mberNm[0]}${mberNm.length > 1 ? "*" : ""}${mberNm.substring(2)}`;
};

// 전화번호에서 가운데 자리 마스킹
export const formatPhoneNumber = (phone) => {
  if (!phone) return "";

  const cleanPhone = phone.replace(/-/g, "");
  return `${cleanPhone.substring(0, 3)}****${cleanPhone.substring(7)}`;
};

export const ButtonStateStyle = (state) => {
  if (state) {
    return {
      pointerEvents: "auto",
      background: "#0074ca",
      cursor: "pointer",
    };
  } else {
    return {
      pointerEvents: "none",
      background: "#555",
      cursor: "default",
    };
  }
};
